"use strict";
var Vector3_1 = require('gdx-ai/lib/math/Vector3');
var SteeringUtils3D_1 = require('./SteeringUtils3D');
;
var SteeringLocation3D_1 = require('./SteeringLocation3D');
var SteeringActor = (function () {
    function SteeringActor(object) {
        this.object = object;
        this.linearVelocity = new Vector3_1.default(object.physics.velocity);
        this.position = new Vector3_1.default(object.position);
        this.angularVelocity = 0;
        this.collisionDistance = 1; // vec3.len(object.physics.aabb.size) / 16;
        this.tagged = false;
        this.maxLinearSpeed = 10;
        this.maxLinearAcceleration = 10;
        this.maxAngularSpeed = 0;
        this.maxAngularAcceleration = 0;
    }
    /** Returns the vector indicating the linear velocity of this Steerable. */
    SteeringActor.prototype.getLinearVelocity = function () {
        return this.linearVelocity;
    };
    /** Returns the float value indicating the the angular velocity in radians of this Steerable. */
    SteeringActor.prototype.getAngularVelocity = function () {
        return this.angularVelocity;
    };
    SteeringActor.prototype.setAngularVelocity = function (velocity) {
        this.angularVelocity = velocity;
    };
    /** Returns the bounding radius of this Steerable. */
    SteeringActor.prototype.getBoundingRadius = function () {
        return this.collisionDistance;
    };
    // @Override
    SteeringActor.prototype.isTagged = function () {
        return this.tagged;
    };
    // @Override
    SteeringActor.prototype.setTagged = function (tagged) {
        this.tagged = tagged;
    };
    /** Returns the vector indicating the position of this location. */
    SteeringActor.prototype.getPosition = function () {
        return this.position;
    };
    /**
     * Returns the float value indicating the orientation of this location. The orientation is the angle in radians representing
     * the direction that this location is facing.
     */
    SteeringActor.prototype.getOrientation = function () {
        return this.object.getYaw();
    };
    /**
     * Sets the orientation of this location, i.e. the angle in radians representing the direction that this location is facing.
     * @param orientation the orientation in radians
     */
    SteeringActor.prototype.setOrientation = function (orientation) {
        this.object.rotateY(orientation - this.getOrientation());
    };
    /**
     * Returns the angle in radians pointing along the specified vector.
     * @param vector the vector
     */
    SteeringActor.prototype.vectorToAngle = function (vector) {
        return SteeringUtils3D_1.vectorToAngle(vector);
    };
    /**
     * Returns the unit vector in the direction of the specified angle expressed in radians.
     * @param outVector the output vector.
     * @param angle the angle in radians.
     * @return the output vector for chaining.
     */
    SteeringActor.prototype.angleToVector = function (outVector, angle) {
        return SteeringUtils3D_1.angleToVector(outVector, angle);
    };
    /**
     * Creates a new location.
     * <p>
     * This method is used internally to instantiate locations of the correct type parameter {@code T}. This technique keeps the API
     * simple and makes the API easier to use with the GWT backend because avoids the use of reflection.
     * @return the newly created location.
     */
    SteeringActor.prototype.newLocation = function () {
        return new SteeringLocation3D_1.default();
    };
    // @Override
    SteeringActor.prototype.getZeroLinearSpeedThreshold = function () {
        return 0.001;
    };
    // @Override
    SteeringActor.prototype.setZeroLinearSpeedThreshold = function (value) {
        throw new Error('Unsupported');
    };
    SteeringActor.prototype.getMaxLinearSpeed = function () {
        return this.maxLinearSpeed;
    };
    SteeringActor.prototype.setMaxLinearSpeed = function (maxLinearSpeed) {
        this.maxLinearSpeed = maxLinearSpeed;
    };
    // @Override
    SteeringActor.prototype.getMaxLinearAcceleration = function () {
        return this.maxLinearAcceleration;
    };
    // @Override
    SteeringActor.prototype.setMaxLinearAcceleration = function (maxLinearAcceleration) {
        this.maxLinearAcceleration = maxLinearAcceleration;
    };
    // @Override
    SteeringActor.prototype.getMaxAngularSpeed = function () {
        return this.maxAngularSpeed;
    };
    // @Override
    SteeringActor.prototype.setMaxAngularSpeed = function (maxAngularSpeed) {
        this.maxAngularSpeed = maxAngularSpeed;
    };
    // @Override
    SteeringActor.prototype.getMaxAngularAcceleration = function () {
        return this.maxAngularAcceleration;
    };
    // @Override
    SteeringActor.prototype.setMaxAngularAcceleration = function (maxAngularAcceleration) {
        this.maxAngularAcceleration = maxAngularAcceleration;
    };
    return SteeringActor;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SteeringActor;
//# sourceMappingURL=SteeringActor.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/SteeringActor.js
 ** module id = 926
 ** module chunks = 0
 **/